import React from 'react';
import { ScreenVoteDecision, VoteDecision } from '../../StudyList';
import styles from './ChangeVoteButton.module.scss';
import { Button, createToast, dismissToast, Toast } from 'components/core';
import { AsyncVoteFunction } from 'hooks/study/useMakeVote';

type ChangeVoteButtonProps = {
  vote: ScreenVoteDecision;
  currentVote: VoteDecision;
  doVote: AsyncVoteFunction;
  isVoting: boolean;
};
const ChangeVoteButton = ({
  vote,
  currentVote,
  doVote,
  isVoting,
}: ChangeVoteButtonProps) => {
  const buttonLabel =
    currentVote === vote ? vote : 'Change vote to ' + vote.toLowerCase();
  const buttonType = currentVote === vote ? 'neutral' : 'brand';

  const onClick = async (): Promise<void> => {
    const savedStudyId = await doVote(vote, false);
    if (!savedStudyId) return;

    dismissToast();
    createToast(
      <Toast type="success" role="alert">
        Vote updated
      </Toast>
    );
  };

  const disabled = currentVote === vote || isVoting;

  return (
    <Button
      disabled={disabled}
      type={buttonType}
      size="sm"
      variant="outline"
      onClick={onClick}
      className={styles.changeVoteButton}
      data-pendo-key="vote-button"
    >
      {buttonLabel}
    </Button>
  );
};

export default ChangeVoteButton;
